import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

import store from "@/store";

export interface AppState {
  lastView: string | null;
  validatedInitiativeAccordion: number | null;
}

export const initialState: AppState = {
  lastView: null,
  validatedInitiativeAccordion: null,
};

@Module({ name: "app", namespaced: true, store })
export class App extends VuexModule implements AppState {
  lastView: string | null = null;
  validatedInitiativeAccordion: number | null = null;
  previousPath: string | null = null;

  @Action({ rawError: true })
  async changeValidatedAccordion(i: number) {
    this.context.commit("setValidatedInitiativeAccordion", i);
  }

  @Mutation
  setLastView(lastView: string) {
    this.lastView = lastView;
  }

  @Mutation
  setPreviousPath(path: string) {
    this.previousPath = path;
  }

  @Mutation
  setValidatedInitiativeAccordion(i: number) {
    this.validatedInitiativeAccordion = i;
  }
}
